export const messageType = {
  announce: 'ANNOUNCE',
  changeCustomer: 'CHANGE-CUSTOMER',
  changeFacility: 'CHANGE-FACILITY',
  language: 'LANGUAGE',
  leave: 'LEAVE',
  login: 'LOGIN',
  logout: 'LOGOUT',
  ping: 'PING',
  theme: 'THEME',
  timeout: 'TIMEOUT',
} as const;
